import { CardContent, Collapse, Divider, ListItem as MuiListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import React, { useMemo, useState } from 'react';

import { ListItemProps } from './ListItem.types';

const ListItem = ({
  text,
  icon,
  isCollapsible = false,
  collapsibleChildren,
  hasCollapsibleDivider = false,
  hasTitleDivider = false,
  isClickable = true,
  openByDefault = false,
  ...props
}: ListItemProps): React.ReactElement => {
  const [isCollapsibleOpen, setIsCollapsibleOpen] = useState<boolean>(openByDefault);
  const toggleOpen = () => setIsCollapsibleOpen(!isCollapsibleOpen);
  const listItemIcon = useMemo(() => (icon ? <ListItemIcon>{icon}</ListItemIcon> : undefined), [icon]);
  const expandIcon = useMemo(
    () =>
      isCollapsible ? isCollapsibleOpen ? <ExpandLess color="primary" /> : <ExpandMore color="primary" /> : undefined,
    [isCollapsible, isCollapsibleOpen]
  );

  return (
    <>
      <MuiListItem
        /**
         * Material UI has a bug: it specifies button as a boolean but doesn't take one
         * This is a temporary workaround
         */
        button={isClickable as any} // eslint-disable-line @typescript-eslint/no-explicit-any
        disableRipple
        onClick={isCollapsible ? toggleOpen : undefined}
        className={props.className}
        divider={hasCollapsibleDivider}
      >
        {listItemIcon}
        <ListItemText primary={text} />
        {expandIcon}
      </MuiListItem>
      <Collapse in={isCollapsibleOpen} unmountOnExit>
        <CardContent>{collapsibleChildren}</CardContent>
      </Collapse>
      {hasTitleDivider && <Divider />}
    </>
  );
};

export { ListItem };
